export default "__VITE_ASSET__hyMe5K3s__"